import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { AuthService } from '~shared/servicios/auth.service';
import { HttpRequestService } from '~shared/servicios/HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class MiTiendaService {

  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}`;
  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlWallet = `${environment.apiTriidyUrlWallet}`;
  private readonly triidyServiceUrlNotification = `${environment.apiTriidyUrlNotifications}`;

  constructor(private http: HttpClient,
    private httpRequestService: HttpRequestService, private authService: AuthService) { }

  /* getMiTienda2(): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key
    });
    return this.http
      .get(`${this.triidyServiceUrl}/GetMiTienda`, {
        params,
        responseType: 'text'
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  } */

  getMiTienda(): Observable<any[]> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: key,
      id_tienda_login: id_tienda,
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/GetMiTienda`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getCiudadesRemitente(pais: string): Observable<any[]> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());
    const nombre_pais = pais;
    switch (pais) {
      case 'Colombia':
        nombre_pais === '57';
        break;
      case 'Ecuador':
        nombre_pais === '593';
        break;
      case 'Mexico':
        nombre_pais === '52';
        break;
    }
    const body = {
      key: key,
      id_tienda_login: id_tienda,
      nombre_pais: nombre_pais,
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/GetCiudadesRemitente`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  updateTienda(oldP: any, newP: any): Observable<any[]> {
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: key,
      token: token,
      id_tienda_login: id_tienda,
      old_psw: oldP,
      psw: newP,
    };
    /*
    Recibe
{
     "token": "7jh95ññtñue2.y3-pw57",
     "id_tienda": "2",
     "key": "Ym8d4sh4a2373tycyr",
     "id_municipio": "5",
     "crear_relaciones": "SI", //SI, NO
     "inventario_negativo": "SI", //SI, NO
     "shopify_api_key": "key",
     "shopify_password": "psw",
     "shopify_tienda": "tienda name",
     "telefono_tienda": "3127925182",
     "celular_operativo": "3127925182",
     "nombre_operativo": "Paulo",
     "direccion_tienda": "Cra"
}
    */

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/UpdateTienda`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  /* getEstadoDocumentacion(tipo): Observable<any> {
    // el tipo puede ser "Tienda" o "Usuario"
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key,
      tipo
    });
    // console.log(params)
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetEstadoDocumentacion`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  } */

  getEstadoDocumentacion(type: any): Observable<any[]> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: key,
      id_tienda_login: id_tienda,
      tipo: type
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/GetEstadoDocumentacion`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  /* adjuntarDocumentacion(tipo_documento?: any, documento?: any, email?: any): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key,
      tipo_documento,
      documento,
      email
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/AdjuntarDocumentacion`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  } */

  adjuntarDocumentacion(tipo_documento?: any, documento?: any, email?: any): Observable<any[]> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      id_tienda_login: id_tienda,
      key: key,
      tipo_documento: tipo_documento,
      documento: documento,
      email: email
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/AdjuntarDocumentacion`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  guardarMiTienda(tiendaForm): Observable<any[]> {
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: key,
      token: token,
      id_tienda: id_tienda,
      id_municipio: tiendaForm.ciudadCtrl,
      shopify_api_key: tiendaForm.apiCtrl,
      shopify_password: tiendaForm.contrasenaCtrl,
      shopify_tienda: tiendaForm.linkCtrl,
      telefono_tienda: tiendaForm.telefonoCtrl,
      direccion_tienda: tiendaForm.direccionCtrl,
      celular_operativo: tiendaForm.telefonoOpCtrl,
      nombre_operativo: tiendaForm.nombreOpCtrl,
      crear_relaciones: tiendaForm.checkRelacionesCtrl === true ? "SI" : "NO",
      inventario_negativo: tiendaForm.checkInventarioCtrl === true ? "SI" : "NO",
    };
    /*
    Recibe
   {
     "token": "7jh95ññtñue2.y3-pw57",
     "id_tienda": "2",
     "key": "Ym8d4sh4a2373tycyr",
     "id_municipio": "5",
     "crear_relaciones": "SI", //SI, NO
     "inventario_negativo": "SI", //SI, NO
     "shopify_api_key": "key",
     "shopify_password": "psw",
     "shopify_tienda": "tienda name",
     "telefono_tienda": "3127925182",
     "celular_operativo": "3127925182",
     "nombre_operativo": "Paulo",
     "direccion_tienda": "Cra"
}
    */
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/UpdateTienda`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getLibreta(): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key,
      codigo_pais
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetLibreta`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  codigoSeguridadCuenta(): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/TwoFactorSend`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  codigoSeguridadCuentaReactivacion(id_tienda_login, key): Observable<any> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/TwoFactorSend`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  validarCodigoSeguridadCuenta(codigo): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      codigo
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/ValidarTwoFactor`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  validarCodigoSeguridadCuentaReactivacion(codigo, id_tienda_login): Observable<any> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      codigo
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/ValidarTwoFactor`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  borrarCuentaLibreta(id_libreta): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      id_libreta,
      key
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/DeleteLibreta`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  AdministrarLibreta(cuentaForm, accionR, codigoTF): Observable<any[]> {
    /*
    *Para poner cuenta predeterminada poner en accion "Default"
    *Para agrega cuenta en la libreta poner en accion "Libreta"
    */
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const body = {
      key: key,
      token: token,
      codigo_pais: codigo_pais,
      id_tienda: id_tienda,
      num_cuenta: cuentaForm.noCuentaCtrl,
      titular: cuentaForm.titularCtrl,
      forma_pago: 'Consignacion',
      banco: cuentaForm.bancoCtrl,
      tipo_cuenta: cuentaForm.tipoCtrl,
      tipo_documento: cuentaForm.tipoDocCtrl,
      documento: cuentaForm.numeroCtrl,
      accion: accionR,
      codigo: codigoTF
    };
    /*
    Recibe
   {
    "token": "Localhost",
    "id_tienda": "2",
    "key": "Ym8d4sh4a2373tycyr",
    "num_cuenta": "543312",
    "titular": "Paulo Velasquez",
    "forma_pago": "Consignacion", //Siempre Consignacion
    "banco": "Bancolombia",
    "tipo_cuenta": "Ahorros", //Ahorros, Corriente
    "tipo_documento": "1", //1=Cedula, 2=Cedula Extranjeria, 3=Nit, 5=Pasaporte
    "documento": "11282678",
    "accion": "Default", //Libreta, Default
    "codigo": "98871" //Two factor
}

    */

    console.log(body);

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/AdministrarLibreta`, body)
      .pipe(
        map((respuesta) => {
          // console.log('resp', respuesta);
          return respuesta;
        }, (err) => {
          // console.log('err', err);
        })
      );
  }

  getBancos(): Observable<any> {
    const token = environment.serviceToken;
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token,
      codigo_pais,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetBancos`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  recargaCuenta(userAg, ip2, valor2): Observable<any> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const body = {
      key: key,
      codigo_pais: codigo_pais,
      id_tienda: id_tienda,
      tipo: 'Tienda',
      ip: ip2,
      user_agent: userAg,
      valor: valor2
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlWallet}/api/Recargas`, body)
      .pipe(
        map((respuesta) => {
          // console.log('resp', respuesta);
          return respuesta;
        }, (err) => {
          // console.log('err', err);
        })
      );
  }


  ignoreUserService(): Observable<any> {
    const usuario = atob(this.authService.leerUserLog());
    const body = {
      UserOrPhone: usuario
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlNotification}/api/IgnoreUser/ignore`, body)
      .pipe(
        map((respuesta) => {
          // console.log('resp', respuesta);
          return respuesta;
        }, (err) => {
          // console.log('err', err);
        })
      );
  }

  unIgnoreUserService(): Observable<any> {
    const usuario = atob(this.authService.leerUserLog());
    const body = {
      UserOrPhone: usuario
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlNotification}/api/IgnoreUser/un-ignore`, body)
      .pipe(
        map((respuesta) => {
          // console.log('resp', respuesta);
          return respuesta;
        }, (err) => {
          // console.log('err', err);
        })
      );
  }

  getIgnoreUsersService(): Observable<any> {
    return this.http
      .get<any>(`${this.triidyServiceUrlNotification}/api/IgnoreUser/ignored-users`)
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
}
